import { createCommand } from '@atlassian/rovo-content-bridge-api';
import type {
	CommandConstructor,
	CommandProperties,
	SerializableValue,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link OpenPreviewPanelCommand}
 */
export interface OpenPreviewPanelCommandProperties extends CommandProperties {
	/**
	 * URL of the content to preview
	 */
	url: string;
	/**
	 * ARI (Atlassian Resource Identifier) of the content
	 */
	ari: string;
}

export const OpenPreviewPanelCommand: CommandConstructor<
	OpenPreviewPanelCommandProperties,
	SerializableValue
> = createCommand<OpenPreviewPanelCommandProperties>('open-preview-panel');

/**
 * @see {@link IsPreviewPanelAvailableCommand}
 */
export interface IsPreviewPanelAvailableCommandProperties extends CommandProperties {
	/**
	 * ARI (Atlassian Resource Identifier) of the content
	 */
	ari: string;
}

export const IsPreviewPanelAvailableCommand: CommandConstructor<
	IsPreviewPanelAvailableCommandProperties,
	boolean
> = createCommand<IsPreviewPanelAvailableCommandProperties, boolean>('is-preview-panel-available');
